// MetaHandler.js
import usePageMeta from '../hooks/usePageMeta';

const MetaHandler = () => {
  usePageMeta();
  return null;
};
export default MetaHandler;
